export const YOUTUBE_API_KEY = 'AIzaSyBrzR50slCfFuV-gOcv_2CW06LzGxR7qO8';
export const YOUTUBE_BASE_URL = 'https://youtube.googleapis.com/youtube/v3';
